<template>
  <el-container>
    <el-header>
      <span>
        {{
          title
        }}
      </span>
    </el-header>
    <el-main>
      <slot name="header" />
      <el-divider v-if="hasLine" />
      <slot name="main" />
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    title: {
      type: String,
      require: false,
      default: ''
    },
    hasLine: {
      type: Boolean,
      require: false,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
.el-container {
  margin-bottom: 22px;
}

.el-header {
  background-color: #b3c0d1;
  line-height: 60px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.el-main {
  background-color: white;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>
